import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setBreadCrumb } from "../../../../store/userSlice";
import DrivingLicenceApply from "./DrivingLicenceApply/DrivingLicienceApply";
import AppliedList from "./AppliedList/AppliedList";
import LicenceRenew from "./LicenceRenew/LicenceRenew";
import { useLocation } from "react-router-dom";

export default function DrivingLicence() {
  const location = useLocation();
  const dispatch = useDispatch();
  //screen Title Show fun
  const titleBorder = [
    { label: "Driving Licence", link: "/dashboard/DrivingLicence" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    if (location.state == null) {
    } else {
      setIndex(1);
    }
  }, []);

  //tab index
  const [index, setIndex] = useState(0);
  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            onClick={() => handleIndex(0)}
            className={`p-2 m-2 h-10 text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            DRIVING LICENCE APPLY
          </button>
          <button
            onClick={() => handleIndex(1)}
            className={`p-2 h-10 m-2 text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            APPLIED LIST
          </button>
          <button
            onClick={() => handleIndex(2)}
            className={`p-2 h-10 m-2 text-black uppercase text-xs mr-4 rounded-md  ${index == 2 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            LICENCE RENEW
          </button>
        </div>
        {index === 0 ? (
          <DrivingLicenceApply />
        ) : index === 1 ? (
          <AppliedList />
        ) : index === 2 ? (
          <LicenceRenew />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
